import React from 'react';
import { Helmet } from 'react-helmet';

import Footer from '../../components/Footer';

import './styles.css';


const Component = () => (
  <div className="terms_main">
    <Helmet>
      <meta name="description" content="We hope to build a lasting relationship with each individual assisting in the growth of Baloo." />
      <title>Baloo: Terms and Conditions</title>
    </Helmet>
    <div className="terms_container">
      <div className="terms_header">
        Terms of Use
      </div>
      <div className="terms_body">
        Thank you for reviewing our terms of use. We’re currently working to define
        them in the best way for you. Until they are defined we just ask that you don’t
        attempt to hack our systems.
        <br />
        <br />
        Once our terms are more clearly defined we’ll notify you of the update so you
        can confirm you agree to the latest terms.
      </div>
    </div>
    <Footer />
  </div>
);

Component.displayName = "Terms";

export default Component;



// WEBPACK FOOTER //
// ./src/views/Terms/index.js